import unauthorizedImg from "../images/unauthorized.png";
import Button from "../components/Button";
import Header from "../components/Header";
import useToggle from "../hooks/useToggle";
import { logtoClient } from "../service/Logto";

function Unauthorized() {
  const {
    value: isLoading,
    setTrue: startLoader,
    setFalse: stopLoader,
  } = useToggle(false);
  const handleSignOut = async () => {
    startLoader();
    try {
      await logtoClient.signOut(`${window.location.origin}/`);
    } catch (error) {
      stopLoader();
    }
  };
  return (
    <div>
      <Header isAuthenticated={false} />
      <div className="sm:pt-[30px] py-6 container space-y-5 min-h-[calc(100dvh-74px)] flex flex-col">
        <div className="flex justify-center items-center flex-auto">
          <div className="w-full">
            <img
              src={unauthorizedImg}
              alt="unauthorizedImg"
              className="mx-auto px-5 mb-12"
            />
            <div className="grid gap-y-10">
              <div>
                <h2 className="sm:text-[32px] text-2xl text-center font-semibold text-gray-700 mb-3">
                  Unauthorized
                </h2>
                <p className="text-center text-gray-500">
                  You don't have access to the Dealer Portal.
                </p>
              </div>
              <Button
                variant="blackGray"
                onClick={handleSignOut}
                btnClassName="mx-auto w-[150px]"
                isLoading={isLoading}
                disabled={isLoading}
              >
                Sign Out
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
